import {Link} from "react-router-dom";


const Section = ({sectionName, imageBanner, itemOne, itemTwo, itemThree, itemFour, sectionNumber, gen , side1='light',side2='light',side3='light',side4='light', id0, id1,id2,id3} )=>{

    function sectionButtonEnter(){
        let section_click = document.createElement('div');
        section_click.className ="sections-click";
        document.getElementsByClassName('sections-image')[sectionNumber]?.appendChild(section_click);
        section_click.innerHTML=`
                        <p>${sectionName}</p>
                    `
    }

    function sectionButtonExit(){
        let section_click = document.getElementsByClassName('sections-click')[0]
        section_click?.remove()
    }

    return (
        <>
            <section className="sections" onMouseEnter={sectionButtonEnter} onMouseLeave={sectionButtonExit}>
                <Link to={'/' + sectionName}><div className="sections-image">
                    <img src={imageBanner} alt='' />
                </div>
                </Link>
            </section>
            <section className={`sections-show ${sectionName} `}>
                <h2 className="sections-show-title">{sectionName}</h2>
                <div className="sections-list">
                    <Link to={`/${sectionName}/${id0}`}>
                        <img src={itemOne} alt='vader' className={`section-item ${side1} `}/>
                    </Link>
                    <Link to={`/${sectionName}/${id1}`}>
                        <img src={itemTwo} alt='riseEmpire' className={`section-item ${side2} `}/>
                    </Link>
                    <Link to={`/${sectionName}/${id2}`}>
                        <img src={itemThree} alt='heirJedi' className={`section-item ${side3} `}/>
                    </Link>
                    <Link to={`/${sectionName}/${id3}`}>
                        <img src={itemFour} alt='masterAprrentice' className={`section-item ${side4} `}/>
                    </Link>

                </div>
                <div className="sections-access">
                    <Link  to={'/'+ sectionName}><button className='button historias-access'>
                        ver tod{gen}s l{gen}s {sectionName}
                    </button></Link>
                </div>

            </section>
        </>
    )
}

export default Section;